import { render, staticRenderFns } from "./ChartAccounts.vue?vue&type=template&id=af172bb0&scoped=true"
import script from "./ChartAccounts.vue?vue&type=script&lang=js"
export * from "./ChartAccounts.vue?vue&type=script&lang=js"
import style0 from "./ChartAccounts.vue?vue&type=style&index=0&id=af172bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af172bb0",
  null
  
)

export default component.exports